import { Router } from '@angular/router';
import { InformacionVisitanteModel } from 'src/app/shared/models/informacionVisitante.model';
import { ConsultaVisitaModalComponent } from './consulta-visita-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UsuarioModel } from 'src/app/models/usuario.model';
import { ParametrosVisitanteModel } from 'src/app/models/parametrosVisitante.model';
import { ReporteVisitaModel } from 'src/app/models/reporteVisita.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { VisitanteModel } from 'src/app/models/visitante.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { isNumber } from 'util';

@Component({
  selector: 'app-consulta-visita',
  templateUrl: './consulta-visita.component.html',
  styleUrls: ['./consulta-visita.component.scss']
})
export class ConsultaVisitaComponent implements OnInit {
  public user: UsuarioModel;
  // datos quemados de usuario
  public rol: string;
  public tipoIdAutorizador: string;
  public numeroIdAutorizador: string;
  //
  public filtroNombreDocumento: string;
  public filtroOrdenamiento: string;
  public filtroAgenda: any;
  public filtroNombre: boolean;

  //
  public parametros: ParametrosVisitanteModel;
  public listaVisitas: ReporteVisitaModel[] = [];
  public listaVisitantes: VisitanteModel[];
  //
  public listaTipoOrdenamiento: any;
  //
  public listaTipoFiltroAgenda: any;
  //
  public tituloConsulta: string;
  public subtituloConsulta: string;
  public subtituloDosConsulta: string;

  private objetoFichaVisitante: any;
  public showDropDownNuevoVisitante: boolean;

  @ViewChild("inputBusquedaVisitas") input2: ElementRef;
  public lecturaLector: boolean = true;
  public valorLector: string = "";
  public numeroDocumentoLector: string = "";
  /**
   * damunoz
   * Constructor de componente
   */
  constructor(
    private urlService: UrlService
    , private spiner: NgxSpinnerService
    , private global: GlobalService
    , private alertService: AlertService
    , private modalService: NgbModal
    , private router: Router
    , private changeDetector: ChangeDetectorRef) {
    this.filtroNombreDocumento = null;
    this.showDropDownNuevoVisitante = false;
    this.filtroNombre = false;
    this.filtroOrdenamiento = null;
    this.tipoIdAutorizador = null;
    this.numeroIdAutorizador = null;
    this.filtroAgenda = 0;

    // this.rol = 'Preautorizador';
    // //this.rol = 'Vigilante'
    // this.tipoIdAutorizador = 'CC';
    // this.numeroIdAutorizador = '1098746630';

    if (sessionStorage.getItem(ConstantesService.ROL_SESSION) === DominiosService.ROL_VIGILANTE) {
      this.rol = ConstantesService.ROL_VALOR_VIGILANTE;
    } else if (sessionStorage.getItem(ConstantesService.ROL_SESSION) === DominiosService.ROL_PREAUTORIZADOR) {
      this.rol = ConstantesService.ROL_VALOR_PREAUTORIZADOR;
    }

    this.tipoIdAutorizador = sessionStorage.getItem(ConstantesService.TIPO_DOC_SESSSION);
    this.numeroIdAutorizador = sessionStorage.getItem(ConstantesService.NUM_DOC_SESSSION);

    this.listaTipoOrdenamiento = [];

    this.listaTipoFiltroAgenda = [];

    this.tituloConsulta = 'titulo';
    this.subtituloConsulta = 'subtitulo';
    this.subtituloDosConsulta = '-';

    // fromero
    // objeto que se envía al modal para mostrar lista de agendas
    this.objetoFichaVisitante = new InformacionVisitanteModel('', '', '', '', '', false, '', '', '', false, '', [], '');
  }

  ngOnInit() {
    /*this.user = this.global.usuario;
    if (this.user.roles == '') {
      this.user = JSON.parse(sessionStorage.getItem('Usuario'));
    }*/
    this.parametros = new ParametrosVisitanteModel(null, null, null, null, null, null, true, 0);
    this.obtenerFiltroAgenda();
    this.obtenerOrdenAgenda();
    this.consultarVisitas();
  }

  ngOnChange() {

  }

  // fromero
  // 29/05/2019
  showDropDown() {
    this.showDropDownNuevoVisitante = !this.showDropDownNuevoVisitante;
  }

  // damunoz
  // método para reiniciar las pantallas de consultas de los roles vigilante y preautorizador
  // a la pantalla principal
  // 21/05/2019
  public volverConsultaPrincipal() {

    this.filtroNombreDocumento = '';
    this.filtroAgenda = 1;
    this.filtroOrdenamiento = 'ASC';
    this.filtroNombre = false;
    this.tipoIdAutorizador = sessionStorage.getItem(ConstantesService.TIPO_DOC_SESSSION);
    this.numeroIdAutorizador = sessionStorage.getItem(ConstantesService.NUM_DOC_SESSSION);
    this.subtituloDosConsulta = '';
    this.reiniciarParametros();
  }

  // damunoz
  // método para reiniciar los valores por defecto de
  // los parametros para filtrar y ordenar la consulta
  // 21/05/2019
  public reiniciarParametros() {
    this.parametros.nombreONumeroDocumento = null;
    this.parametros.ordenamiento = null;
    this.parametros.tipoIdVisitante = null;
    this.parametros.numeroIdVisitante = null;
    this.parametros.idFuncionario = null;
    this.parametros.numeroIdFuncionario = null;
    this.parametros.filtrodia = true;
    this.parametros.estadoVisita = 0;

    this.spiner.hide();

    this.consultarVisitas();
  }

  // damunoz
  // método para obtener los filtros de agenda de la base de datos y aplicarlos al select
  // 21/05/2019
  public obtenerFiltroAgenda() {
    this.spiner.show();
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'FiltroAgenda']);
    const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);

    this.global.getGenerico(url).subscribe(
      data => {
        if (data.length <= 1) {
          this.cathException('No hay estados de visita disponibles');
        } else {
          this.listaTipoFiltroAgenda = data;
        }
        this.spiner.hide();
      }, err => {
        this.cathException('No es posible Obtener estados de visita', err);
      }
    );
  }

  // damunoz
  // método para obtener los tipos de ordenamiento de la base de datos y aplicarlos al select
  // 21/05/2019
  public obtenerOrdenAgenda() {
    this.spiner.show();
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'OrdenAgenda']);
    const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);

    this.global.getGenerico(url).subscribe(
      data => {
        if (data.length <= 1) {
          this.cathException('No hay Ordenamiento de Agenda Disponible');
        } else {
          this.listaTipoOrdenamiento = data;
        }
        this.spiner.hide();
      }, err => {
        this.cathException('No es posible Obtener tipo de ordenamiento', err);
      }
    );
  }

  // damunoz
  // método para realizar la consulta en base de datos y obtener las agendas segun los
  // parametros de filtro y ordenamiento que se coloquen previamente
  // 21/05/2019
  public consultarVisitas(valor?: string) {
    this.lecturaLector=true;
    const serviceProvider = 'ConsultaAgendasDia';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
    if (this.filtroNombreDocumento == ' ') {
      this.filtroNombreDocumento = undefined;
      this.numeroDocumentoLector = '';
    }
    if (this.filtroNombreDocumento && this.filtroNombreDocumento.trim().length > 0) {
      this.parametros.nombreONumeroDocumento = this.filtroNombreDocumento;
    }
    if (this.rol === ConstantesService.ROL_VALOR_PREAUTORIZADOR) {
      this.tituloConsulta = ConstantesService.VISITANTES_CON_AGENDA;
      this.subtituloConsulta = ConstantesService.SUBTITULO_VISITANTES_CON_AGENDA;
      this.parametros.idFuncionario = this.tipoIdAutorizador;
      this.parametros.numeroIdFuncionario = this.numeroIdAutorizador;
    } else {
      this.tituloConsulta = ConstantesService.VISITANTES;
      this.subtituloConsulta = ConstantesService.SUBTIULO_VISITANTES;
      this.parametros.idFuncionario = null;
      this.parametros.numeroIdFuncionario = null;
    }
    if (valor === 'BUSCAR') {
      if (this.filtroNombreDocumento != null && this.filtroNombreDocumento.trim().length > 0) {
        if (this.rol === ConstantesService.ROL_VALOR_PREAUTORIZADOR) {
          this.filtroAgenda = 1;
        } else {
          this.filtroAgenda = 3;
        }
        this.filtroNombre = true;
        this.parametros.idFuncionario = null;
        this.parametros.numeroIdFuncionario = null;
        this.parametros.filtrodia = false;
      } else {
        this.filtroNombre = false;
        this.volverConsultaPrincipal();
      }
    } else if (valor !== 'BUSCAR' && valor !== null) {
      if (this.filtroNombreDocumento && this.filtroNombreDocumento.length > 0) {
        this.filtroNombre = true;
        this.parametros.idFuncionario = null;
        this.parametros.numeroIdFuncionario = null;
      }
    }

    if (this.filtroAgenda === 0) {
      this.parametros.estadoVisita = 1;
    } else {
      this.parametros.estadoVisita = this.filtroAgenda;
    }
    this.parametros.ordenamiento = this.filtroOrdenamiento;
    this.spiner.show();
    this.global.postGenerico(url, this.parametros).subscribe(
      (data: ReporteVisitaModel[]) => {
        this.listaVisitas = data;
        this.listaVisitas.forEach(element => {
          element.banderaConsultaVisitas = true;
          element.banderaRol = this.rol;
          element.banderaFechaDia = this.validarFechaHoy(element.agendaVisita);
        });
        if (this.rol === ConstantesService.ROL_VALOR_PREAUTORIZADOR && valor === 'BUSCAR') {
          if (this.listaVisitas.length === 0) {
            this.comprobarExistenciaVisitante();
          } else if (this.listaVisitas.length === 1 && this.filtroNombreDocumento != null && this.filtroNombreDocumento.length > 0) {
            this.tituloConsulta = ConstantesService.RESULTADO_DE_BUSQUEDA;
            this.subtituloConsulta = ConstantesService.SUBTITULO_UN_RESULTADO;
            this.spiner.hide();
          } else {
            this.spiner.hide();
          }
        } else if (this.rol === ConstantesService.ROL_VALOR_VIGILANTE) {
          if (this.filtroNombreDocumento != null && this.listaVisitas.length === 0) {
            this.tituloConsulta = ConstantesService.RESULTADO_DE_BUSQUEDA;
            this.subtituloConsulta = ConstantesService.SUBTITULO_NO_ENCONTRADO_VIGILANTE;
            this.subtituloDosConsulta = ConstantesService.SUBTITULO_DOS_VIGILANTE;
            this.spiner.hide();
          } else if (this.filtroAgenda === '2') {
            if (this.listaVisitas.length !== 0) {
              this.tituloConsulta = ConstantesService.VISITAS_ACTIVAS;
              this.subtituloConsulta = ConstantesService.SUBTITULO_ACTIVOS;
              this.spiner.hide();
            } else {
              this.spiner.hide();
            }
          } else {
            this.spiner.hide();
          }
        } else {
          this.spiner.hide();
        }
      }, (err: any) => {
        this.cathException('No es posible realizar la consulta de visitas', err);
      }
    );

  }

  cathException(error: string, err?: any) {
    this.alertService.generateAlertError(error, ' ');
    this.spiner.hide();
  }

  // damunoz
  // método para comprobar que el numero de documento ingresado exista en los visitantes
  // registrados en la base de datos
  // 21/05/2019
  public comprobarExistenciaVisitante(): boolean {
    this.spiner.show();
    let existencia = false;
    const serviceProvider = 'ObtenerVisitante';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=visitantePK.numDocVisitante', this.filtroNombreDocumento]);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.getGenerico(url).subscribe(
      data => {
        if (data.length < 1) {
          existencia = false;
        } else {
          this.listaVisitantes = [];
          data.forEach(
            (v: {
              correoVisitante: string;
              empresa: string;
              nombreCompleto: string;
              tipo: string;
              visitantePK: { tipoDocVisitante: string; numDocVisitante: string; };
            }) => {
              this.listaVisitantes.push(
                new VisitanteModel(v.correoVisitante,
                  v.empresa,
                  v.nombreCompleto,
                  v.tipo,
                  v.visitantePK.tipoDocVisitante,
                  v.visitantePK.numDocVisitante)
              );
            });
          existencia = true;
        }
        this.spiner.hide();
        this.mostrarExistenciaVisitante(existencia);
      }, err => {
        this.cathException('No es posible consultar existencia de visitante', err);
      }
    );
    return existencia;
  }

  // damunoz
  // método para mostrar lo correspondiente en pantalla según la existencia
  // o no del numero de documento ingresado en los visitantes de la BD
  // 21/05/2019
  public mostrarExistenciaVisitante(existencia: boolean) {
    this.spiner.show();
    if (existencia) {
      this.listaVisitantes.forEach(visitante => {
        this.listaVisitas.push(new ReporteVisitaModel(
          'No programada',
          '',
          '',
          'No programada',
          '',
          visitante.nombreCompleto,
          'No programada', '', '', '', '',
          visitante.tipoDocumento,
          visitante.numeroDocumento, null, '', 'No programada', '', '', 0, false, '', true));
      });
      this.spiner.hide();
    } else {
      this.tituloConsulta = ConstantesService.RESULTADO_DE_BUSQUEDA;
      this.subtituloConsulta = ConstantesService.SUBTITULO_NO_ENCONTRADO_PREAUTORIZADOR;
      this.subtituloDosConsulta = ConstantesService.SUBTITULO_DOS_PREAUTORIZADOR;
      this.spiner.hide();
    }
  }

  // damunoz
  // método para validar que la fecha que ingresa como parametro sea de hoy
  // 21/05/2019
  public validarFechaHoy(fecha: string): boolean {
    let esFechaHoy = false;
    const fechaVisita = fecha.split(' ')[0];
    const diaFechaVisitaint = parseInt(fechaVisita.split('/')[0], null);
    const mesFechaVisitaint = parseInt(fechaVisita.split('/')[1], null) - 1;
    const annioFechaVisitaint = parseInt(fechaVisita.split('/')[2], null);
    const fechaDate = new Date(annioFechaVisitaint, mesFechaVisitaint, diaFechaVisitaint);
    const fechaHoyDate = new Date();
    fechaHoyDate.setHours(0, 0, 0, 0);
    if (fechaDate.getTime() === fechaHoyDate.getTime()) {
      esFechaHoy = true;
    }
    return esFechaHoy;
  }

  // fromero
  // 21/05/2019
  // handler para lanzar metodo de ver más agendas
  verMasAgendas(event) {

    this.spiner.show();
    if (event) {
      const obj: ReporteVisitaModel = JSON.parse(event.objeto);
      const tipoIdVisitante = obj.tipoIdVisitante;
      const numeroIdVisitante = obj.numeroIdVisitante;
      const fecha = obj.agendaVisita;
      const fechaFiltro = this.formattDate(fecha);

      setTimeout(() => {
        this.getInformacionVisitante(tipoIdVisitante, numeroIdVisitante, fechaFiltro);
      }, 1000);

    }
    this.spiner.show();
  }


  // fromero
  // metodo para  formatear fecha
  // 21/05/2019

  formattDate(fechaFormat: any) {
    // se construye la fecha
    let fechaResult: string;
    if (fechaFormat) {
      fechaResult = fechaFormat.split(' ')[0];
      const fecha = fechaResult.split('/');
      fechaResult = fecha[0] + '/' + fecha[1] + '/' + fecha[2];
      return fechaResult;
    }
  }


  // fromero:
  // método para inyectar un componente dentro del modal,
  // se envía componente y opciones de modal
  // 14/05/2019
  public vermodal() {
    const modalRef = this.modalService.open(ConsultaVisitaModalComponent,
      { centered: true, windowClass: 'myCustomModalClass' });
    modalRef.componentInstance.InformacionVisitante = this.objetoFichaVisitante; // Objeto que se envìa al modal para ediciòn
  }

  // fromero
  // método de consulta de información de visitante Básica y agendas del día
  // 13/05/2019
  getInformacionVisitante(tipoIdVisitante, numeroIdVisitante, fecha) {

    const serviceProvider = 'ObetenerInformacionAgendasVisitante';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    queryParams.push(['tipoDocumento', tipoIdVisitante]);
    queryParams.push(['numeroDocumento', numeroIdVisitante]);
    queryParams.push(['fechaConsulta', fecha]);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.postGenerico(url).subscribe(
      data => {

        this.objetoFichaVisitante = data[0];
        this.spiner.hide();
        this.vermodal();

      }, err => {
        this.cathException('No fue posible consultar las agendas');
      }
    );
  }

  refrescarConsulta(event) {
    this.consultarVisitas();
  }

  // fromero
  // 09/05/2019
  // metodo de redirecciòn a cu_003 o cu_004 o CU_023
  nuevoVisitante(pagina) {

    switch (pagina) {
      case 'nuevo':
        this.router.navigate(['main/registrar-nueva-visita']);
        break;
      case 'masiva':
        this.router.navigate(['main/registro-visita-masiva']);
        break;
      case 'cancelar':
        this.router.navigate(['main/cancelar-visita-masiva']);
        break;
      case 'eliminar':
          this.router.navigate(['main/eliminar-agenda-masiva']);
          break;
    }
  }

  mychange(event){
  if(this.lecturaLector===true){
    this.filtroNombreDocumento=event;
  }
    
    /**let numero;
       numero= Number(event);  
       if(!Number.isNaN(numero)){
        this.filtroNombreDocumento=String(numero);      
        console.log("filtroNombreDocumento "+this.filtroNombreDocumento);      
       }       
    **/
  }

  onKey(event: KeyboardEvent) {
    
    event.preventDefault();
    if (event.key === "Tab"){
   console.log("tab");
   
      if(this.lecturaLector===true){
        console.log("Numero "+
        this.input2.nativeElement.value);
        this.valorLector = this.input2.nativeElement.value;
        this.lecturaLector=false;       
        this.filtroNombreDocumento=this.valorLector;                            
      } 
      this.input2.nativeElement.value=this.filtroNombreDocumento;     
      this.input2.nativeElement.focus();      
         
    }
  }

 

}
